import { Col, Form, InputNumber } from 'antd';
import React from 'react'

const InjectionMouldlingFields = ({ prefix, form }) => {
  return (
    <>
      <Col xs={24} md={4}>
        <Form.Item
          label="Cavity"
          name={[prefix, "cavity"]}
          rules={[
            {
              required: true,
              message: "Please input Cavity number...!",
            },
          ]}
        >
          <InputNumber
            defaultValue={0}
            precision={0}
            style={{ width: "100%" }}
            placeholder="Cavity"
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item
          label="Cycle Time"
          name={[prefix, "cycle_time"]}
          rules={[
            {
              required: true,
              message: "Please input Cycle time...!",
            },
          ]}
        >
          <InputNumber
            addonAfter="seconds"
            placeholder="Cycle Time"
            precision={0}
            defaultValue={0}
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item label="Shot Weight" name={[prefix, "shot_weight"]}>
          <InputNumber
            addonAfter="gm"
            precision={2}
            defaultValue={0}
            style={{ width: "100%" }}
            placeholder="Shot Weight"
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item
          label="Part Weight"
          name={[prefix, "part_weight"]}
          rules={[
            {
              type: "number",
              min: 0,
              validator: (_, value) => {
                const shotWeightValue = form.getFieldValue([
                  "meta",
                  "shot_weight",
                ]);
                if (
                  typeof shotWeightValue !== "number" ||
                  isNaN(shotWeightValue) ||
                  shotWeightValue === null
                ) {
                  return Promise.resolve();
                }
                if (value > shotWeightValue) {
                  return Promise.reject(
                    new Error("Part Weight cannot exceed Shot weight.")
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <InputNumber
            addonAfter="gm"
            placeholder="Part Weight"
            defaultValue={0}
            precision={2}
            style={{ width: "100%" }}
            min={0}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item
          label="Units / box"
          name={[prefix, "units_per_box"]}
          rules={[
            {
              required: true,
              message: "Please Enter Units Per Box...!",
            },
            {
              type: "number",
              min: 1,
              message: "Units Per Box must be at least 1",
            },
          ]}
        >
          <InputNumber
            defaultValue={1}
            placeholder="Units Per Box"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
    </>
  )
}

export default InjectionMouldlingFields